import "./App.css";
import Layout from "./Layout.js";

function App() {
  return <Layout />;
}

export default App;
